<script setup>
import { onBeforeMount, onUnmounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import SectionHeader from "../components/texts/SectionHeader.vue";
import { BASE_PATH } from "../const/route";
import BaseView from "./BaseView.vue";

const route = useRoute();
const router = useRouter();
const invoice = ref(null);

onBeforeMount(() => {
    const sessionId = route.query.sessionId;
    const invoiceDetails = localStorage.getItem(sessionId);

    if (!invoiceDetails) {
        router.replace(BASE_PATH);
    } else {
        invoice.value = JSON.parse(invoiceDetails);
    }
});

onUnmounted(() => {
    localStorage.clear();
});
</script>

<template>
    <BaseView>
        <div class="self-center text-center my-16">
            <SectionHeader
                label="Payment cancelled"
                :show-divider="false"
                class="mb-8"
            />
            <p v-if="invoice" class="mb-8">Reference: {{ invoice.id }}</p>
            <router-link to="/" replace>Return to Home page</router-link>
        </div>
    </BaseView>
</template>
